import { useQuery } from 'react-query';
import LocationInterface from '@solvhealth/types/interfaces/Location';
import { apiGetJson } from '~/core/dapi';
import { DAPI_HOST } from '~/config';

/**
 * A hook that returns the number of patients currently on the wait list for a location
 *
 * @returns
 *   loading state
 *   valid data boolean
 *   wait list count
 */
export default function useWaitListCount(
  location: LocationInterface,
  { enabled = true }: { enabled?: boolean } = {}
) {
  const { data, isLoading, isError } = useQuery(
    ['wait-time', location?.id],
    () =>
      apiGetJson<{ data?: number }>(`${DAPI_HOST}/v1/locations/${location?.id}/wait-list-count`),
    {
      staleTime: 5 * 60 * 1000,
      enabled,
    }
  );

  const waitListCount = data?.data;
  const isValidWaitListCount = Number.isInteger(waitListCount) && !isError;

  return { isLoading, isValidWaitListCount, waitListCount };
}
